<template>
    <div>
        <m-pane
            ref="tablePage"
            class="tablePage"
            :initSearchInfo="initSearchInfo"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="currentPage"
            unique="etdoNo"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @searchChange="searchChange"
            @selectChange="selectChange"
            @upload-btn="uploadBtn"
            @showAccessory-btn="showAccessoryBtn"
            :searchTotalTitle="config.searchTotalTitle"
            searchId="test"
            pageID="test"
        >
            <div slot="table-module-btn">
                <reportExport #default="{ submit }" reportCode="REPORT-LSP-LMS-RECEPITE-SIGN">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'05050105'">
                            <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button type="primary" @click="receiptOverdue" v-has="'05050103'">回单逾期</el-button>
                <el-button type="primary" @click="arriveOverdue" v-has="'05050104'">到货逾期</el-button>
            </div>
        </m-pane>
        <el-dialog
            v-if="accessoryVisible"
            title="附件查看"
            :visible.sync="accessoryVisible"
            width="50%"
            @close="accessoryVisible = false"
        >
            <el-table :data="accessoryTableData" style="width: 100%" border :loading="Tbloading">
                <el-table-column
                    prop="mdrfTaskNo"
                    show-overflow-tooltip
                    label="运输单号"
                    sortable
                    width="180"
                ></el-table-column>
                <el-table-column
                    prop="mdrfFileNo"
                    show-overflow-tooltip
                    label="文件编号"
                    sortable
                    width="180"
                ></el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    label="文件名称"
                    sortable
                    prop="mdrfFileName"
                    width="180"
                >
                    <template slot-scope="scope">
                        <a
                            v-if="scope.row.mdrfFileNo && scope.row.mdrfFileNo.includes('http')"
                            :href="scope.row.mdrfFileNo"
                            :download="scope.row.mdrfFileName"
                            target="_blank"
                        >{{scope.row.mdrfFileName}}</a>
                        <a
                            v-else
                            :href="`${configs.apiUrl}/api-srm-web/order/ltms/download?id=${scope.row.mdrfFileNo}`"
                            :download="scope.row.mdrfFileName"
                            target="_blank"
                        >{{scope.row.mdrfFileName}}</a>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    label="上传时间"
                    sortable
                    width="180"
                ></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="accessoryVisible = false">取 消</el-button>
                <el-button
                    type="primary"
                    @click="() => {
                        accessoryVisible = false;
                        this.$refs.tablePage.$refs.searchList.onSearchChange();
                    }"
                >确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="文件上传"
            :visible.sync="uploadVisible"
            width="50%"
            @close="handleSaveFilesClose"
        >
            <el-upload
                class="upload"
                action
                multiple
                :before-upload="beforeUpload"
                :http-request="httpRequest"
                with-credentials
                :file-list="fileList"
            >
                <el-button size="small" type="primary">上传文件</el-button>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="() => {this.handleSaveFilesClose()}">取 消</el-button>
                <el-button type="primary" @click="handleSaveFiles" :loading="saveFileLoading">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="回单逾期"
            :visible.sync="receiptVisible"
            width="60%"
            @close="handleReceiptClose"
        >
            <el-form
                ref="form"
                inline
                :model="ruleForm"
                label-position="right"
                label-width="150px"
                :rules="rules"
            >
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="回单逾期一级原因" prop="receiptReason1">
                            <otpSelect
                                style="width: 180px"
                                :optionNum="'OTP_CHANGE_RECEIPT_1'"
                                :mValue="ruleForm.receiptReason1"
                                @getSelectValue="getReceiptSelectValue"
                                :prop="'receiptReason1'"
                            ></otpSelect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="回单逾期二级原因" prop="receiptReason2">
                            <el-select v-model="ruleForm.receiptReason2" placeholder="请选择">
                                <el-option
                                    v-for="item in receiptReasonTwoOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="逾期原因描述">
                            <el-input
                                v-model="ruleForm.overdueRemark"
                                placeholder="请输入内容"
                                style="width: 180px;"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="() => {this.handleReceiptClose()}">取 消</el-button>
                <el-button type="primary" @click="handleReceiptChange">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="到货逾期"
            :visible.sync="arriveVisible"
            width="60%"
            @close="handleArriveClose"
        >
            <el-form
                ref="form"
                inline
                :model="ruleForm"
                label-position="right"
                label-width="150px"
                :rules="rules"
            >
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="到货逾期一级原因" prop="arriveReason1">
                            <otpSelect
                                style="width: 180px"
                                :optionNum="'OTP_CHANGE_DELIVERY_1'"
                                :mValue="ruleForm.arriveReason1"
                                @getSelectValue="getArriveSelectValue"
                                :prop="'arriveReason1'"
                            ></otpSelect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="到货逾期二级原因" prop="arriveReason2">
                            <el-select v-model="ruleForm.arriveReason2" placeholder="请选择">
                                <el-option
                                    v-for="item in arriveReasonTwoOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="逾期原因描述">
                            <el-input
                                v-model="ruleForm.overdueRemark"
                                placeholder="请输入内容"
                                style="width: 180px;"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="() => {this.handleArriveClose()}">取 消</el-button>
                <el-button type="primary" @click="handleArriveChange">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import mPane from '@/components/supplierPanel';
import otpSelect from '@/components/lots/otpSelect';
import reportExport from '@/components/lots/reportExportPlugin';
import config from './config.js';
import { maxDay } from '@/modules/transport/tms/common/common';
import {
    getSignList,
    selFile,
    fileUpload,
    saveFile,
    saveReceiptOverDueReason,
    saveArriveOverDueReason
} from '../../../api/receiptManage';
import { getDictionaryDetailByCode } from '../../../api/appointment';
import dayjs from 'dayjs';
import configs from '@/config/user.env';
import common from '../../../common/common';
import { mapGetters } from 'vuex';
const { getSessionKey, initSessionData } = common;
const isScreenTaskStatus = 'Y';
export default {
    components: { mPane, otpSelect, reportExport },
    created () {
        this.initRouter();
    },
    activated () {
        this.initRouter(true);
    },
    mounted () {
        initSessionData(['SYS_TMS_ZTB_FLAG']);
        // this.$refs.tablePage.$refs.searchList.onSearchChange();
    },
    computed: {
        ...mapGetters(['supplier', 'currentTenant'])
    },
    data () {
        return {
            config,
            configs,
            initSearchInfo: {}, // 用于设置初始默认值
            selectArray: [], // 选中的集合
            totalData: [], // table数据
            pageTotal: 0, // 总条数
            loading: false, // table的loading状态
            currentPage: 1, // 当前页数
            pageSize: 10, // 每页数量
            searchData: {}, // 搜索的对象结果
            accessoryTableData: [], // 查看附件table
            accessoryVisible: false, // 查看附件弹窗
            Tbloading: false, // 查看附件table
            rowData: null, // 上传行的数据
            uploadVisible: false, // 上传弹窗
            fileList: [], // 上传文件列表
            saveFileLoading: false, // 上传文件弹窗按钮loading
            receiptVisible: false, // 回单逾期弹窗
            receiptReasonTwoOptions: [], // 回单逾期二级原因可选项
            arriveVisible: false, // 到货逾期弹窗
            arriveReasonTwoOptions: [], // 到货逾期二级原因可选项
            ruleForm: {
                overdueRemark: '', // 回单与到货逾期原因描述
                receiptReason1: '', // 回单逾期一级原因
                receiptReason2: '', // 回单逾期二级原因
                arriveReason1: '', // 到货逾期一级原因
                arriveReason2: '' // 到货逾期二级原因
            },
            exportParams: {},
            isFirstSearch: true,
            rules: {
                receiptReason1: [
                    { required: true, message: '请选择一级原因', trigger: 'change' }
                ],
                receiptReason2: [
                    { required: true, message: '请选择二级原因', trigger: 'change' }
                ],
                arriveReason1: [
                    { required: true, message: '请选择一级原因', trigger: 'change' }
                ],
                arriveReason2: [
                    { required: true, message: '请选择二级原因', trigger: 'change' }
                ]
            }
        };
    },
    methods: {
        _validateSearchParams (data) {
            if (!data.createTimeFrom) {
                return '创建日期不能为空！';
            }
            const beginDate = dayjs(data.createTimeFrom).valueOf() || 0;
            const endDate = dayjs(data.createTimeTo).valueOf() || 0;
            const differenceValue = endDate - beginDate;
            if (differenceValue > maxDay) {
                return '按时间查询或导出时，时间跨度不可超过一个月！';
            }
        },
        _getList (pageNo = 1) {
            const msg = this._validateSearchParams(this.searchData);
            if (msg) return this.$message.warning(msg);
            this.loading = true;
            const {
                SYS_TRANSPORT_TASK_STATUS,
                SYS_LTMS_UPLOAD_STATUS,
                SYS_TS_DELIVERY_RECEIPT_STATUS,
                SYS_TMS_ZTB_FLAG
            } = sessionStorage;
            this.exportParams = {
                mddrCarrierEbcuCode: this.supplier.supplierCode,
                isScreenTaskStatus,
                ...this.searchData
            };
            getSignList({
                pageNo,
                pageSize: this.pageSize,
                mddrCarrierEbcuCode: this.supplier.supplierCode,
                isScreenTaskStatus,
                ...this.searchData
            }).then((res) => {
                if (res && res.data && +res.code === 0) {
                    const { list, totalCount, pageNo } = res.data;
                    this.totalData = list.map(item => {
                        // 运输单状态
                        item.ettaStatusType = getSessionKey(item.ettaStatus, SYS_TRANSPORT_TASK_STATUS);
                        // 上传状态
                        item.mddrElectronicExistType = getSessionKey(item.mddrElectronicExist, SYS_LTMS_UPLOAD_STATUS);
                        // 签收状态
                        item.mddrStatusType = getSessionKey(item.mddrStatus, SYS_TS_DELIVERY_RECEIPT_STATUS);
                        // 直通宝标识
                        item.ztbzcldType = getSessionKey(item.ztbzcld, SYS_TMS_ZTB_FLAG);
                        return item;
                    });
                    this.pageTotal = totalCount;
                    this.currentPage = +pageNo;
                }
                this.loading = false;
            });
        },
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (!this.isFirstSearch) {
                const msg = this._validateSearchParams(this.searchData);
                if (msg) return this.$message.warning(msg);
            }
            submit({ ...this.exportParams, carrierCode: this.supplier.supplierCode, tenantCode: this.currentTenant.tenantCode });
            this.isFirstSearch = false;
        },
        // 查看附件
        _selFile (mddrTaskNo) {
            this.Tbloading = true;
            selFile({ mddrTaskNo }).then(res => {
                if (res) {
                    if (res.data.success) {
                        this.accessoryTableData = res.data.data;
                    } else {
                        this.$message.error(res.data.messagesAsString);
                    }
                }
                this.Tbloading = false;
            });
        },
        // 上传文件
        _fileUpload (uploadData) {
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('files', file);
            fileUpload(formData).then(res => {
                if (res && +res.code === 0) {
                    this.fileList.push({
                        name: file.name,
                        mdrfTaskNo: this.rowData.mddrTaskNo,
                        mdrfFileName: file.name,
                        mdrfFileNo: res.data.data || res.data,
                        uploadContact: this.supplier.supplierNameCn
                    });
                }
            });
        },
        _saveFile () {
            this.saveFileLoading = true;
            saveFile({
                models: [this.rowData],
                files: this.fileList
            }).then(res => {
                if (res) {
                    if (res.data.success) {
                        this.$message.success('上传成功!');
                        this.handleSaveFilesClose();
                    } else {
                        this.$message.error(res.data.messagesAsString); // 提示信息或错误消息
                    }
                }
            }).finally(() => {
                this.saveFileLoading = false;
            });
        },
        // 获取数据字典
        _getDictionaryDetailByCode (key) {
            return getDictionaryDetailByCode({ dictCodes: key }).then(res => {
                if (res && +res.code === 0) {
                    return res.data;
                }
            });
        },
        // 回单逾期
        _saveReceiptOverDueReason () {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    this.$message.error('请正确填写表单!');
                    return false;
                } else {
                    saveReceiptOverDueReason({
                        mddrOverdueReason: this.ruleForm.receiptReason1,
                        mddrOverdueSecReason: this.ruleForm.receiptReason2,
                        mddrOverdueRemark: this.ruleForm.overdueRemark,
                        mddrIds: this.selectArray.map(item => item.mddrId)
                    }).then(res => {
                        if (res && +res.code === 0) {
                            if (!res.data) {
                                this.$message.error(res.data.messagesAsString);
                            } else {
                                this.$message.success('操作成功!');
                                this.handleReceiptClose(true);
                            }
                        }
                    });
                }
            });
        },
        _saveArriveOverDueReason () {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    this.$message.error('请正确填写表单!');
                    return false;
                } else {
                    saveArriveOverDueReason({
                        mddrArriveOverdueReason: this.ruleForm.arriveReason1,
                        mddrArriveOverdueSecReason: this.ruleForm.arriveReason2,
                        mddrArriveOverdueRemark: this.ruleForm.overdueRemark,
                        mddrIds: this.selectArray.map(item => item.mddrId)
                    }).then(res => {
                        if (res && +res.code === 0) {
                            if (!res.data) {
                                this.$message.error(res.data.messagesAsString);
                            } else {
                                this.$message.success('操作成功!');
                                this.handleArriveClose(true);
                            }
                        }
                    });
                }
            });
        },
        initRouter (isCache) {
            if (this.$route.query.ettaStatus && this.$route.query.mddrElectronicExist) {
                this.initSearchInfo = {
                    ettaStatus: this.$route.query.ettaStatus,
                    mddrElectronicExist: this.$route.query.mddrElectronicExist
                };
                this.$router.replace(this.$route.path);
                this.$nextTick(() => {
                    this.$refs.tablePage.$refs.searchList.onSearchChange();
                });
            }
        },
        pageChange (val) {
            this.currentPage = val;
            this._getList(val);
        },
        handleClickFile (id) {
            window.open(`${configs.apiUrl}/api-srm-web/order/ltms/download?id=${id}`);
        },
        sizeChange (val) {
            this.pageSize = val;
            this._getList();
        },
        // 查询结果
        searchChange (val) {
            val = this.formattingData(val);
            this.searchData = val;
            this._getList();
        },
        formattingData (data) {
            const tempData = {
                createTimeFrom: data.createTime && data.createTime.length ? dayjs(data.createTime[0]).format('YYYY-MM-DD HH:mm:ss') : '',
                createTimeTo: data.createTime && data.createTime.length ? dayjs(data.createTime[1]).format('YYYY-MM-DD HH:mm:ss') : '',
                mddrEtdoDepartDateFrom: data.departTime && data.departTime.length ? dayjs(data.departTime[0]).format('YYYY-MM-DD HH:mm:ss') : '',
                mddrEtdoDepartDateTo: data.departTime && data.departTime.length ? dayjs(data.departTime[1]).format('YYYY-MM-DD HH:mm:ss') : '',
                ...data
            };
            delete tempData.createTime;
            delete tempData.departTime;
            return tempData;
        },
        selectChange (data) {
            this.selectArray = data;
        },
        uploadBtn (row) {
            this.rowData = row;
            this.uploadVisible = true;
        },
        showAccessoryBtn (row) {
            this.accessoryVisible = true;
            this._selFile(row.mddrTaskNo);
        },
        beforeUpload (file) {
            if (file.size > 100 * 1024 * 1024) {
                this.$message.warning('文件超过限制大小 ' + 100 + 'M！');
                return false;
            }
            return true;
        },
        httpRequest (file) {
            this._fileUpload(file);
        },
        handleSaveFiles () {
            if (!this.fileList.length) {
                this.$message.error('请先上传文件');
                return false;
            } else {
                this._saveFile();
            }
        },
        handleSaveFilesClose () {
            this.uploadVisible = false;
            this.rowData = null;
            this.fileList = [];
        },
        receiptOverdue () {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            for (const item of this.selectArray) {
                if (item.etta2b2c === 'ELS') {
                    this.$message.error('电商单据不允许做回单逾期登记');
                    return false;
                }
            }
            this.receiptVisible = true;
        },
        handleReceiptClose (req) {
            this.receiptVisible = false;
            this.ruleForm.overdueRemark = '';
            this.ruleForm.receiptReason1 = '';
            this.ruleForm.receiptReason2 = '';
            this.ruleForm.receiptReasonTwoOptions = [];
            this.$refs.form.resetFields();
            if (req) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        handleReceiptChange () {
            this._saveReceiptOverDueReason();
        },
        getReceiptSelectValue (data) {
            this.ruleForm.receiptReason2 = '';
            this.receiptReasonTwoOptions = [];
            if (data.receiptReason1) {
                this._getDictionaryDetailByCode('OTP_CHANGE_RECEIPT_2').then(res => {
                    const arr = res.OTP_CHANGE_RECEIPT_2;
                    for (const key in arr) {
                        if (arr[key] && key && +key.split('_')[0] === +data.receiptReason1) {
                            this.receiptReasonTwoOptions.push({
                                label: arr[key],
                                value: key
                            });
                        }
                    }
                });
            }
            this.ruleForm = Object.assign({}, this.ruleForm, data);
        },
        arriveOverdue () {
            if (!this.selectArray.length) {
                this.$message.error('请选中一条数据');
                return false;
            }
            for (const item of this.selectArray) {
                if (item.etta2b2c === 'ELS') {
                    this.$message.error('电商单据不允许做回单逾期登记');
                    return false;
                }
            }
            this.arriveVisible = true;
        },
        handleArriveClose (req) {
            this.arriveVisible = false;
            this.ruleForm.overdueRemark = '';
            this.ruleForm.arriveReason1 = '';
            this.ruleForm.arriveReason2 = '';
            this.ruleForm.arriveReasonTwoOptions = [];
            this.$refs.form.resetFields();
            if (req) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
        },
        handleArriveChange () {
            this._saveArriveOverDueReason();
        },
        getArriveSelectValue (data) {
            this.ruleForm.arriveReason2 = '';
            this.arriveReasonTwoOptions = [];
            if (data.arriveReason1) {
                this._getDictionaryDetailByCode('OTP_CHANGE_DELIVERY_2').then(res => {
                    const arr = res.OTP_CHANGE_DELIVERY_2;
                    for (const key in arr) {
                        if (arr[key] && key && +key.split('_')[0] === +data.arriveReason1) {
                            this.arriveReasonTwoOptions.push({
                                label: arr[key],
                                value: key
                            });
                        }
                    }
                });
            }
            this.ruleForm = Object.assign({}, this.ruleForm, data);
        }
    }
};
</script>
